/** Set to true when blog pages are ready for launch */
export const BLOG_ENABLED = false;

export const BLOG_PATHS = [
  '/blogs',
  '/rising-star',
  '/marketing-5-signs',
  '/festival',
  '/boost-productivity',
  '/barbie',
  '/meta-ai',
  '/public-speaking-skills',
  '/hashtags',
  '/networking-enterprise',
  '/linked-in',
  '/power-spoken-word',
  '/digital-frontier',
];
